export class WfNotification {
	icon?:any;
	text:any;
	duration:number = 3000;
	classes?:string;
	readonly id:string = `${new Date().getTime()}-${Math.random()}` ;
}